import latinize from 'latinize'
import {FC} from 'react'
import Highlighter from 'react-highlight-words'

import {Link} from '@/i18n'
import {theme} from '@/theme/theme'

import {Text} from '../../common/content/Text'

type SidebarSearchResultsProps = {
  data: {
    title: string
    linkHref: string
  }[]
  searchWords?: string[]
  onClick?: () => void
}

export const SidebarSearchResults: FC<React.PropsWithChildren<SidebarSearchResultsProps>> = ({
  data,
  searchWords,
  onClick,
}) => {
  return (
    <>
      <ul className="list">
        {data.map(({linkHref, title}) => (
          <li key={`article-${title}`} className="article" onClick={onClick} role="presentation">
            <Text color={theme.palette.text.white}>
              <Link href={linkHref} legacyBehavior>
                <a className="link">
                  {searchWords ? (
                    <Highlighter
                      searchWords={searchWords}
                      sanitize={latinize}
                      autoEscape
                      textToHighlight={title}
                      highlightClassName="highlighted"
                    />
                  ) : (
                    title
                  )}
                </a>
              </Link>
            </Text>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .article + .article {
          margin-top: ${theme.spacing[4]};
        }

        .article:last-of-type {
          padding-bottom: ${theme.spacing[5]};
        }

        .link {
          color: inherit;
        }
      `}</style>
      <style jsx global>{`
        .highlighted {
          background-color: ${theme.palette.primary.main};
        }
      `}</style>
    </>
  )
}
